import { DataProvider, useMutation } from "@nf/common";

export const useCancelSubscriptionSwitch = () => {
  return useMutation(() => DataProvider.cancelSubscriptionSwitch());
};
